const status_list = ['', '员工', '编外']

export function initFinderConfig (ctx) {
  let that = ctx
  if (!that) return console.error('finder初始化未接收到绑定上下文')
  return {
    requestUrl: process.env.VUE_APP_BASE_API + '/commission/lists',
    columns: [
      {
        name: '员工工号',
        key: 'employee_number'
      },
      {
        name: '员工姓名',
        key: 'salesperson_name'
      },
      {
        name: '员工类型',
        key: 'employee_status',
        render: (h, { row }) => {
          // jsx语法支持单元格渲染
          return (
            <div class='status'>
              {row.employee_status && <span>{status_list[row.employee_status]}</span>}
            </div>
          )
        }
      },
      {
        name: '当前所属门店',
        key: 'store_name'
      },
      {
        name: '门店编号',
        key: 'store_bn'
      },
      {
        name: '当月业绩(元)',
        key: 'performance',
        render: (h, { row }) => {
          // jsx语法支持单元格渲染
          return <div> {row.performance / 100} </div>
        }
      },
      {
        name: '上月提成订单退款',
        key: 'abnormal_commisson',
        render: (h, { row }) => {
          // jsx语法支持单元格渲染
          return <div> {row.abnormal_commisson / 100} </div>
        }
      },
      {
        name: '当月未确认提成(元)',
        key: 'unconfirmed_commisson',
        render: (h, { row }) => {
          // jsx语法支持单元格渲染
          return <div> {row.unconfirmed_commisson / 100} </div>
        }
      },
      {
        name: '当月确认提成(元)',
        key: 'confirmed_commisson',
        render: (h, { row }) => {
          // jsx语法支持单元格渲染
          return <div> {row.confirmed_commisson / 100} </div>
        }
      }
    ],
    search: [
      { key: 'month', name: '', slot: 'month' },
      { key: 'name', name: '', slot: 'name' },
      { key: 'guide', name: '', slot: 'guide' }
    ],
    actions: [
      {
        name: '导出提成',
        key: 'create',
        slot: 'header',
        type: 'button',
        buttonType: 'primary',
        action: {
          handler: () => {
            that.$exportList({
              filesType: 17,
              showStoreSelect: true,
              exportDate: 'month',
              isDateSingle: true,
              showEmployeeStatus: true,
              showSalesPersonStatus: true
            })
          }
        }
      },
      {
        name: '查看当月提成计算规则',
        key: 'create',
        slot: 'header',
        type: 'button',
        buttonType: 'text',
        action: {
          handler: () => {
            that.$rulesDiaolog({
              month: that.params.month
            })
          }
        }
      },
      {
        name: '明细',
        key: 'create',
        type: 'button',
        buttonType: 'text',
        action: {
          type: 'link',
          path: (row, selections) => `/customerConversion/commissionReport/${row.salesperson_id}` // 方法方式跳转
        }
      }
    ]
  }
}

export default initFinderConfig
